import FieldStatus from "../../../../fields3/generic/status/status"
import FieldConfig from "../../../../fields3/proto/field-config"
import ProjectStatusManager from "../../../../gd/manager/project-status-manager"
import {ColorPalette, DefaultPaletteColorNumber, ItemColorCoding} from "../../../color-coding/color-coding"
import {SystemStatusOptions} from "../../../../gd/const/system-status";
import FieldProjectStatus_DropdownValueNotEmpty from "./components/multiselect/value-not-empty";
import FieldProjectStatus_ConditionForm from "./render/condition";

export default class FieldProjectSystemStatus extends FieldStatus {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Project System Status";

        this.noValueOption                  = false // system status always set

        // this.options                    = ProjectStatusManager.getSystemStatusOptions()
        this.options                        = SystemStatusOptions

        this.components.PopoverMenuMore     = null
        this.components.FormValueNotEmpty   = FieldProjectStatus_DropdownValueNotEmpty

        this.renderComponents.conditionForm = FieldProjectStatus_ConditionForm
        this.renderComponents.filterForm    = FieldProjectStatus_ConditionForm
    }

    access(model:any) {
        return gd.ac.check.project.fullAccess(model.id) ? 'write' : 'read';
    }

    _getOption(value:any) {
        // try dynamic status
        let status = gd.session.statuses.get(value)
        if (status) {
            return status
        }

        // try finding via system statuses

        if (this.hasOptionWithNullValue || !_.isNil(value)) {
            // !!! '==' is intentional to make no difference for number and string
            // !!! '==' is intentional to make no difference for number and string
            // !!! '==' is intentional to make no difference for number and string
            const option = _.find(this.getOptions(), option => option.value == value); // DON CHANGE !!!
            if (option) return option;
        }

        return false;
    }

    getOptionsForEdit(model:any) {
        return ProjectStatusManager.getProjectStatusOptions(model)
    }

    getColorCoding(model: any): ItemColorCoding {
        const value = _.get(model, this.fieldId, null)
        const status = this._getOption(value)

        return {
            colorNumber         : status?.color || DefaultPaletteColorNumber.STATUS,
            corePalette         : ColorPalette.STATUS
        }
    }
}
